import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import React from 'react'

enum ImageSide {
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundImage: any
  imageSide: ImageSide
  // cloudinaryImage: any
  // cloudinaryMobileImage: any
  builderImage: any
  builderMobileImage: any
  imageAltText: string
  imageBackdropColor: string
  contentText: string
  backgroundColor: string
  imageOne: string
  imageTwo: string
  contextFooter: string
}

const OurStoryImage = ({
  backgroundImage = '',
  imageSide,
  // cloudinaryMobileImage,
  // cloudinaryImage,
  builderImage,
  builderMobileImage,
  imageAltText = '',
  imageBackdropColor,
  contentText,
  backgroundColor,
  imageOne,
  imageTwo,
  contextFooter
}: Props) => {
  const signatureIndex = contextFooter?.lastIndexOf(',')
  const founder = signatureIndex > 0 && contextFooter.slice(0, signatureIndex + 1).trim()
  const oraganization = signatureIndex > 0 && contextFooter.slice(signatureIndex + 1, contextFooter.length).trim()

  const getContent = () => {
    if (imageSide === ImageSide.Left) {
      return (
        <>
          <div className="lg:absolute lg:inset-0">
            <div className="top-auto lg:absolute lg:inset-y-0 lg:left-0 lg:top-1/2 lg:h-full lg:w-1/2 lg:-translate-y-1/2">
              <CdnImage
                className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                url={builderImage}
                alt={imageAltText}
                steps={[700]}
                style={{
                  width: '705px',
                  height: '1275px',
                  maxHeight: '100%',
                  maxWidth: '100%'
                }}
              />
              {/* {builderImage ? (
                <CdnImage
                  className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                  url={builderImage}
                  alt={imageAltText}
                  steps={[700]}
                  style={{
                    width: '705px',
                    height: '1275px',
                    maxHeight: '100%',
                    maxWidth: '100%'
                  }}
                />
              ) : (
                <CloudinaryImage
                  className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                  publicId={cloudinaryImage?.public_id}
                  alt={imageAltText}
                  steps={[700]}
                  style={{
                    width: '705px',
                    height: '1275px',
                    maxHeight: '100%',
                    maxWidth: '100%'
                  }}
                />
              )} */}
              <CdnImage
                className="block object-contain lg:absolute lg:hidden"
                url={builderMobileImage}
                alt={imageAltText}
                steps={[480]}
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: '18rem'
                }}
              />
              {/* {builderMobileImage ? (
                <CdnImage
                  className="block object-contain lg:absolute lg:hidden"
                  url={builderMobileImage}
                  alt={imageAltText}
                  steps={[480]}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '18rem'
                  }}
                />
              ) : (
                <CloudinaryImage
                  className="block object-contain lg:absolute lg:hidden"
                  publicId={cloudinaryMobileImage?.public_id}
                  alt={imageAltText}
                  steps={[480]}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '18rem'
                  }}
                />
              )} */}
            </div>
          </div>

          <div className="relative h-full w-full px-4 pt-4 pb-6 sm:px-6 sm:pt-16 md:pt-12 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:px-8">
            <div className="col-span-2 lg:col-start-2 lg:pl-8">
              <div className="word-break-fix mx-auto max-w-prose text-base lg:ml-auto lg:mr-0">
                <div className={`mx-auto w-4/5 rounded-2xl p-4 lg:w-1/2 max-w-[650px]`} style={{ backgroundColor }}>
                  <img src={imageOne} className="float-left -mt-8 w-8" alt="" />
                  <div className="relative mx-auto flex pt-2 text-center font-sans">
                    <p
                      className="enable-list-styles h-full w-full text-base"
                      dangerouslySetInnerHTML={{ __html: contentText }}
                    ></p>
                  </div>
                  <img src={imageTwo} className="float-right w-8" alt="" />
                </div>
                <div className="font-third max-h-full max-w-full text-3xl text-black sm:text-5xl lg:ml-10">
                  {signatureIndex > 0 ? (
                    <>
                      <p>{founder}</p>
                      <p>{oraganization}</p>
                    </>
                  ) : (
                    contextFooter
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className="mx-auto flex h-full w-full lg:w-11/12 flex-col-reverse lg:flex-row 2xl:container">
          <div className="mx-auto h-full max-h-[1000px] min-h-[24rem] w-full justify-center text-center lg:mt-16 lg:w-1/2 lg:text-left">
            <div className="col-span-2 lg:col-start-1 lg:pl-8">
              <div className="word-break-fix mx-auto max-w-prose text-base lg:mr-auto lg:ml-0 ">
                <div className="mx-auto mt-4 mb-10 flex max-h-full max-w-full flex-col gap-y-3 md:ml-10 md:gap-y-1 lg:ml-0">
                  <div
                    className={`relative mx-auto w-4/5 rounded-2xl p-4 lg:p-8 lg:w-11/12`}
                    style={{ backgroundColor }}
                  >
                    <img src={imageOne} className="absolute -top-3 lg:-top-4 left-4 w-8" alt="" />
                    <div className="relative mx-auto flex pt-2 text-center font-sans">
                      <p
                        className="enable-list-styles h-full w-full text-base"
                        dangerouslySetInnerHTML={{ __html: contentText }}
                      ></p>
                    </div>

                    <img src={imageTwo} className="absolute -bottom-4 lg:-bottom-4 right-4 w-8" alt="" />
                  </div>
                </div>
                <div className="font-third max-h-full max-w-full text-3xl text-[#004355] sm:text-5xl !font-normal lg:ml-10 -rotate-3">
                  {signatureIndex > 0 ? (
                    <>
                      <p>{founder}</p>
                      <p>{oraganization}</p>
                    </>
                  ) : (
                    contextFooter
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 block w-full lg:w-1/2 lg:pt-8">
            <div className="max-h-448 relative mx-auto mb-12 h-auto w-[70%] rounded-lg lg:h-[24rem]">
              <div
                className="image-backdrop-square-wrapper absolute h-full w-full rounded-[30px] lg:h-[25rem] lg:max-w-[34rem]"
                style={{ backgroundColor: imageBackdropColor }}
              />
              <CdnImage
                className="index-2 height-specifier relative h-full rounded-[30px] object-cover"
                url={builderImage}
                alt={imageAltText}
                steps={[315, 390, 515, 640]}
              />
              {/* {builderImage ? (
                <CdnImage
                  className="index-2 height-specifier relative h-full rounded-[30px] object-cover"
                  url={builderImage}
                  alt={imageAltText}
                  steps={[315, 390, 515, 640]}
                />
              ) : (
                <CloudinaryImage
                  className="index-2 height-specifier relative h-full rounded-[30px] object-cover"
                  publicId={cloudinaryImage?.public_id}
                  alt={imageAltText}
                  steps={[315, 390, 515, 640]}
                />
              )} */}
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div
        className="relative mx-auto flex w-full flex-col items-center justify-center bg-white bg-auto bg-no-repeat lg:flex-row lg:bg-100%"
        style={{ backgroundImage: `url(${backgroundImage ?? ''})` }}
      >
        {getContent()}
      </div>
    </>
  )
}

export default OurStoryImage

Builder.registerComponent(OurStoryImage, {
  name: 'OurStoryImage',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'imageSide',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryMobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'imageBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'imageOne',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageTwo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'contextFooter',
      type: 'string',
      defaultValue: ''
    }
  ]
})
